// extracted by mini-css-extract-plugin
export var actionButton = "_dy-0";
export var fileInput = "_dy-2";
export var paperclip = "_dy-1";